import { mdlPremiumMainCoversCompRenewal } from "./mdlPremiumMainCoversCompRenewal";


export class mdlProposalAddCompRenewalReq {
    public POLICYNO: string;
    public BankName: string;
    public Insured_IBANNO: string;
    public Insured_EmailId:string;
    public Insured_IDNo:string;
    public ScreenShot: string ;
    public IsHigherPosition:boolean;
    public HigherPositionCode :number;
    public CoverDetails: Array<mdlPremiumMainCoversCompRenewal> = new Array<mdlPremiumMainCoversCompRenewal>();
    public ReferredBy: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlProposalAddCompRenewalReq.ts